<template>
    <select :name="name" :disabled="disabled">
        <option v-if="isEmpty"></option>
        <option v-if="isAll" value="all">{{trans('labels.filters.all')}}</option>
        <option v-if="isUndefined" value="undefined">{{trans('labels.filters.undefined')}}</option>
        <option v-for="option in options" :value="option.value">
            <a>{{ option.label }}</a>
        </option>
    </select>
</template>

<script>
    import '../../../../vendor/almasaeed2010/adminlte/bower_components/select2/dist/js/select2.full.js';
    import '../../../../vendor/almasaeed2010/adminlte/bower_components/select2/dist/js/i18n/de.js';

    export default {
        props: {
            name: '',
            selected: '',
            value: {
                default: null
            },
            options: {
                type: Array,
                default() {
                    return []
                }
            },
            placeholder: {
                type: String,
                default: 'Placeholder'
            },
            onChange: {
                type: Function | String,
                default: function () {
                }
            },
            onSelect: {
                type: Function | String,
                default: function () {
                }
            },
            initSelectConfig: {
                type: Object,
                default: function () {
                    return {}
                },
                required: false
            },
            disabled: Boolean,
            isAll: Boolean,
            isUndefined: Boolean,
            isEmpty: Boolean,
            fillNotAll: {
              type: Boolean,
              default: false
            },
            disabledOptions: {
                type: Array,
                default: function() {
                    return []
                }
            }
        },
        data() {
            return {
                selectConfig: {
                    placeholder: this.placeholder,
                    closeOnSelect: true,
                    dropdownAutoWidth: true,
                    width: 'auto',
                    language: 'de'
                },
                defaultValue: this.selected,
                nameLocal: this.name,
                isReset: false
            }
        },
        computed: {
            all: {
                get: function () {
                }
            },
            valueJson: function () {
                return this.value;
            }
        },
        methods: {
            setupSelect: function () {
                // Set up config common properties and certaina chart properties
                $.extend(
                    true,
                    this.selectConfig,
                    this.initSelectConfig
                );
            }
        },
        mounted: function () {
            var self = this;
            self.defaultValue = self.selected;

            if(self.disabledOptions.length > 0){
                self.disabledOptions.forEach(function(disopt){
                    $('select option[value="'+disopt+'"]').prop('disabled', true);
                });
            }

            setImmediate(function () {
                var onChangeCallback = self.onChange;
                var onSelect = self.onSelect;

                var prevArr = [];

                self.setupSelect();
                $(self.$el)
                    .select2(self.selectConfig)
                    .val(self.selected)
                    .trigger('change')
                    .on('change', function (event) {
                        var $select2Container = $(this).parent().find('.select2-container'),
                            prefix = ($(this).val() !== self.defaultValue) ? 'add' : 'remove';

                        self.$emit('input', [$(this).val(), event]);

                        if (typeof onChangeCallback === 'string' && typeof window[onChangeCallback] === 'function') {
                            window[onChangeCallback]($(this).val(), event);
                        } else if (typeof onChangeCallback === 'function') {
                            onChangeCallback($(this).val(), event);
                        }

                        $select2Container[prefix + 'Class']('is-changed');
                    }).on('select2:select', function (e) {

                    if ($(self.$el).attr('multiple') && $(self.$el).val().length > 1) {
                        var currArr = $(this).val();
                        var diff = $(currArr).not(prevArr).get();

                        if (diff[0] == 'all' || diff[0] == 'selectable') {
                            $(self.$el).val(diff).trigger('change');
                        } else {
                            if (currArr.indexOf('all') >= 0 || currArr.indexOf('selectable') >= 0) {
                                $(self.$el).val(diff).trigger('change');
                            }
                        }
                    }

                    if (typeof onSelect === 'string' && typeof window[onSelect] === 'function') {
                        window[onSelect]($(this).val());
                    } else if (typeof onSelect === 'function') {
                        onSelect($(this).val());
                    }
                }).on('select2:selecting', function () {
                    prevArr = $(this).val();
                }).on('select2:unselecting', function(e) {
                  let options = $(this).find('option'),
                      values = $.map(options ,function(option) {
                        if (option.value !== 'all') {
                          return option.value;
                        }
                      }),
                      closedOptions = $(this).val();
                  if (self.fillNotAll && $(self.$el).attr('multiple') && closedOptions.indexOf('all') >= 0 && closedOptions.length == 1) {
                    $(self.$el).val(values).trigger('change');
                    e.preventDefault();
                    return false;
                  }
              });
            });
        },
        watch: {
            value: function (value) {
                var self = this;
                this.$nextTick(function () {
                    $(self.$el).val(value);
                });
            },
            options: function (options) {
                var val = 'all';

                if (!this.isReset && options.length > 0 && this.defaultValue && this.defaultValue != val) {
                    val = this.defaultValue;
                    this.isReset = false;
                } else {
                    this.defaultValue = null;
                }

                if ($(this.$el).hasClass("select2-hidden-accessible")) {
                    $(this.$el).select2('destroy');
                    this.$nextTick(function () {
                        $(this.$el).select2(options);
                        $(this.$el).trigger('change');
                        $(this.$el).val(val).trigger('change');
                    });

                }
            }
        },
        destroyed: function () {
            if ($(this.$el).hasClass("select2-hidden-accessible")) {
                $(this.$el).off().select2('destroy');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Select2.vue